import { TAG_TYPES } from 'types/services';

import { coreApi } from '.';
import type { UserAgendaNotification } from 'types';

export const userNotificationsService = coreApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getUserAgendaNotifications: builder.query<UserAgendaNotification[], { actionRequired?: boolean; agendaIds?: string[] }>({
      query: ({ actionRequired = false, agendaIds = [] }) => ({
        url: 'UserNotifications/Me/Filtered',
        method: 'POST',
        body: { actionRequired, agendaIds },
      }),
      providesTags: [TAG_TYPES.USER_NOTIFICATIONS],
    }),
  }),
});
export const { useGetUserAgendaNotificationsQuery } = userNotificationsService;
